var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUy = function SvgUy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 32",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h51.15v31.998H0V0z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.932 8.662c-.632-.183-1.25-.243-2.028-.61-.82-.698-.88-.92-1.402-1.126-.196-.07-.34-.04-.67-.32-.42-.445-.253-.652-.05-.82.172.1.226.214.706.21.272.01.66.083 1.04.288.3.235.672.558 1.108.71.52.12.706.24 1.063.224.417.03.485.116.835.247.158.638-.046.908-.604 1.196zM7.957 7.06c-.303-.552-.69-1.007-.956-1.786-.044-1.037.085-1.233-.125-1.726-.084-.18-.207-.256-.226-.67.044-.595.32-.63.588-.61.046.184-.004.3.335.62.183.188.4.5.51.897.032.365.046.84.235 1.24.274.43.313.64.575.867.27.302.252.406.398.733-.374.553-.722.606-1.333.434zM9.867 6.618c.2-.59.268-1.17.666-1.897.75-.764.988-.818 1.21-1.305.076-.184.045-.318.345-.625.48-.39.7-.233.875-.042-.105.16-.23.21-.23.66-.01.255-.09.618-.312.974-.252.28-.6.625-.765 1.032-.13.487-.26.66-.246.995-.037.39-.128.454-.27.78-.683.145-.97-.048-1.273-.574zM11.55 7.566c.585-.287 1.068-.653 1.897-.906 1.106-.048 1.316.07 1.84-.128.192-.08.272-.196.715-.215.634.04.67.296.652.548-.195.044-.32-.002-.66.317-.2.173-.53.378-.953.484-.388.03-.894.047-1.32.226-.458.26-.68.297-.92.544-.32.254-.433.24-.78.377-.592-.348-.65-.675-.47-1.248zM12.03 9.355c.63.184 1.25.246 2.027.615.82.698.878.922 1.4 1.128.195.07.34.04.667.32.42.448.252.655.05.82-.172-.097-.226-.213-.706-.21-.272-.01-.66-.083-1.04-.29-.3-.235-.67-.558-1.105-.712-.52-.12-.706-.24-1.063-.226-.418-.032-.486-.117-.836-.25-.157-.637.048-.907.607-1.194zM9.11 11.396c-.195.592-.26 1.17-.654 1.9-.744.77-.983.825-1.202 1.313-.075.183-.044.318-.342.626-.477.394-.697.237-.874.046.104-.16.228-.21.225-.66.01-.256.09-.62.308-.977.252-.28.597-.628.76-1.036.13-.488.258-.663.24-.998.035-.392.125-.455.266-.784.68-.148.97.044 1.275.568zM7.418 10.452c-.585.29-1.067.656-1.896.91-1.106.052-1.316-.067-1.84.134-.19.08-.27.197-.714.217-.634-.037-.672-.294-.654-.547.195-.045.32 0 .658-.32.2-.172.53-.378.953-.486.39-.032.895-.05 1.32-.23.457-.26.68-.3.92-.547.32-.255.43-.24.778-.38.593.348.652.674.474 1.248z",
    fill: "rgba(0, 0, 0, 0.56078)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.88 3.657h32.27V7.3H18.88V3.656zM18.88 10.747h32.27v3.642H18.88v-3.643z",
    fill: "#002993"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.033 10.934c.31.547.704.998.98 1.773.06 1.037-.067 1.234.15 1.724.086.18.21.254.234.67-.037.594-.31.63-.58.614-.048-.183 0-.3-.343-.615-.186-.187-.407-.495-.523-.892-.035-.365-.056-.84-.25-1.236-.28-.428-.32-.637-.587-.86-.274-.3-.258-.404-.408-.73.367-.556.715-.613 1.328-.45z",
    fill: "rgba(0, 0, 0, 0.56078)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.754h51.15v3.642H0v-3.642zM0 24.803h51.15v3.642H0v-3.642z",
    fill: "#002993"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.42 11.177l-.938 4.815v-4.815h.938z",
    fill: "#FAFF00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.543 11.177l.938 4.815v-4.815h-.937z",
    fill: "#F5C402"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.785 9.915l2.976 4.022-3.637-3.4.662-.622z",
    fill: "#FAFF00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.46 11.162l4.3 2.775-3.637-3.4-.662.624z",
    fill: "#F5C402"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.796 8.122l5.138.87-5.136.01-.002-.88z",
    fill: "#FAFF00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 9.882l5.134-.89-5.136.01.002.88z",
    fill: "#F5C402"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.46 6.85l4.303-2.772-3.64 3.397-.662-.624z",
    fill: "#FAFF00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.785 8.098l2.978-4.02-3.64 3.397.662.624z",
    fill: "#F5C402"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54 6.837l.927-4.817.01 4.815-.938.002z",
    fill: "#FAFF00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.416 6.833l-.95-4.813.01 4.815.94-.002z",
    fill: "#F5C402"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.178 8.097L4.202 4.075l3.64 3.398-.663.623z",
    fill: "#FAFF00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.503 6.85l-4.3-2.775L7.84 7.473l.663-.623z",
    fill: "#F5C402"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.176 9.91L2.03 9.083l5.136-.053.01.88z",
    fill: "#FAFF00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.155 8.15l-5.125.933 5.136-.053-.01-.88z",
    fill: "#F5C402"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.525 11.17l-4.273 2.813 3.605-3.43.67.617z",
    fill: "#FAFF00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.188 9.935l-2.936 4.048 3.605-3.43-.67-.617z",
    fill: "#F5C402"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.132 9.01c0 1.357-1.186 2.457-2.65 2.457s-2.65-1.1-2.65-2.456c0-1.355 1.186-2.455 2.65-2.455s2.65 1.1 2.65 2.456z",
    fill: "#FAFF00"
  })));
};
export default SvgUy;